import { CARTSTATES, THEME } from 'Assets/js/lib/constants'
import CountdownTimer from 'Assets/js/lib/countdown-timer'
import { updateItemById, addItemById } from 'Assets/js/lib/cart'
import { getCartAttributeProperties } from 'Assets/js/lib/form'
;(function () {
  const components = {
    cartLineItemAction: SAXX.Init.Component((node, ctx) => {
      node.addEventListener('click', async (e) => {
        e.preventDefault()
        const properties = {}
        JSON.parse(node.getAttribute('data-line-properties')).forEach(
          ([key, value]) => {
            properties[key] = value
          },
        )

        const formData = {
          id: node.getAttribute('data-id'),
          quantity: Number(node.getAttribute('data-quantity')),
          properties,
        }

        const response = await updateItemById(formData)

        if (!response || response.status === 'bad_request') {
          node.disabled = false
          return ctx.emit(CARTSTATES.UPDATINGERROR, null)
        }

        ctx.emit(CARTSTATES.UPDATED, null, { cart: response })
      })
    }),
    cartDrawerUpdate: SAXX.Init.Component((node, ctx) => {
      ctx.on(CARTSTATES.UPDATED, (_, { cart } = { cart: {} }) => {
        node.querySelectorAll('[data-update-section]').forEach((section) => {
          const sectionName = section.getAttribute('data-update-section')
          const cartMarkup = new DOMParser().parseFromString(
            cart?.sections['cart-drawer'],
            'text/html',
          )
          const sectionMarkup = cartMarkup?.querySelector(
            `[data-update-section="${sectionName}"]`,
          )

          if (!sectionMarkup) return

          section.replaceWith(sectionMarkup)
        })

        if (typeof window.Nosto === 'object') {
          Nosto.reloadCart()
        }

        SAXX.App.mount()
      })
      ctx.on(CARTSTATES.UPDATINGERROR, (_, { cart } = { cart: {} }) => {
        node.querySelector('[data-error-section]').innerHTML =
          SAXX.Messages.AddToCartError
        setTimeout(() => {
          node.querySelector('[data-error-section]').innerHTML = ''
        }, 3000)
      })
    }),
    countdownTimer: SAXX.Init.Component((node, ctx) => {
      new CountdownTimer(node, {
        endDate: node.getAttribute('data-end-date'),
        countdownMessage: node.getAttribute('data-countdown-message'),
        fallbackMessage: node.getAttribute('data-fallback-message'),
      })
    }),
    cartDrawerProductCardAction: SAXX.Init.Component((node, ctx) => {
      node.addEventListener('change', async () => {
        const formData = new FormData(node)
        const variantID = formData.get('id')
        const properties = getCartAttributeProperties(formData)

        const response = await addItemById(variantID, '1', properties)

        if (!response || response.status === 422) {
          return ctx.emit(CARTSTATES.UPDATINGERROR, null, {
            cart: response,
          })
        }

        ctx.emit(CARTSTATES.UPDATED, null, { cart: response })

        node
          .querySelectorAll('.quick-shop--input')
          .forEach((input) => (input.checked = false))
      })
    }),
    cartGiftWithPurchaseTrigger: SAXX.Init.Component((node, ctx) => {
      ctx.on('gwp:offerUpdate', (_, { offerResults }) => {
        node.classList.toggle('hidden', offerResults.valid.length === 0)
      })

      node.querySelector('button').addEventListener('click', (e) => {
        e.preventDefault()
        ctx.emit(THEME.modalControlInteraction, null, {
          controlElement: 'gift-with-purchase',
        })
      })
    }),
  }

  SAXX.Init.AddComponents(components)
})()
